import styled from "styled-components";
import { reviewTokens } from "./theme";

export const LeftButtonSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const RightActionSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SectionWrapper = styled.div`
  padding: 16px 20px;
`;

export const SectionTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.01em;
  margin-bottom: 12px;
  color: ${reviewTokens.textPrimary};
`;

export const TableWrapper = styled.div`
  padding: 0 20px;
`;

export const CommentsToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0 12px;
  border-bottom: 1px solid ${reviewTokens.border};
  margin-bottom: 12px;
  position: sticky;
  top: 0;
  background: ${reviewTokens.bgPaper};
  z-index: 1;
`;

export const ThreadGroup = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid ${reviewTokens.border};
  &:last-child {
    border-bottom: none;
  }
`;

export const ReplyIndent = styled.div`
  margin-left: 40px;
  padding-left: 16px;
  border-left: 2px solid ${reviewTokens.border};
  margin-top: 8px;
`;

export const HistoryTimelineItem = styled.div`
  padding: 12px 8px;
  border-bottom: 1px solid ${reviewTokens.border};
  &:last-child {
    border-bottom: none;
  }
`;

export const UrlRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: ${reviewTokens.bgMuted};
  border-radius: ${reviewTokens.radiusSm}px;
  margin-top: 8px;
  word-break: break-all;
  font-family: ${reviewTokens.fontMono};
  font-size: 12px;
`;

export const InviteFormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const StatusBadge = styled.span<{ color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: ${reviewTokens.radiusSm}px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #fff;
  background: ${(props) => props.color};
`;

export const ChangeRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 12px;
  padding: 12px;
  border: 1px solid ${reviewTokens.border};
  border-radius: ${reviewTokens.radiusMd}px;
  background: ${reviewTokens.bgPaper};
  margin-bottom: 8px;
  transition: border-color 0.15s ease, background 0.15s ease;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    border-color: ${reviewTokens.borderStrong};
    background: ${reviewTokens.slate50};
  }
`;

